import { useState, useEffect } from 'react';
import { ImageCache } from './cache';
import { getImageSize } from './getImageSize';
export function useImageSize(uri) {
    const [imageSize, setImageSize] = useState(uri ? ImageCache[uri] : undefined);
    useEffect(() => {
        if (!uri) {
            setImageSize(undefined);
            return;
        }
        let cancel;
        async function run(uri) {
            let size;
            try {
                const operation = getImageSize(uri);
                cancel = operation.cancel;
                size = await operation.start();
                cancel = undefined;
                ImageCache[uri] = size;
            }
            catch (error) {
                if (__DEV__)
                    console.warn("Failed to get image size", error);
            }
            setImageSize(size);
        }
        const cached = ImageCache[uri];
        if (cached) {
            setImageSize(cached);
        }
        else {
            run(uri);
        }
        return () => {
            if (cancel) {
                cancel();
            }
        };
    }, [uri, setImageSize]);
    return {
        imageSize,
        aspectRatio: imageSize && imageSize.height !== 0
            ? imageSize.width / imageSize.height
            : undefined,
    };
}
//# sourceMappingURL=useImageSize.js.map